/* tslint:disable */
/* eslint-disable */
/**
 * e-SNRWB
 * Opis api e-SNRWB
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportProductsByMisstatement
 */
export interface ReportProductsByMisstatement {
    /**
     * 
     * @type {object}
     * @memberof ReportProductsByMisstatement
     */
    details: object;
    /**
     * 
     * @type {object}
     * @memberof ReportProductsByMisstatement
     */
    sum: object;
}

export function ReportProductsByMisstatementFromJSON(json: any): ReportProductsByMisstatement {
    return ReportProductsByMisstatementFromJSONTyped(json, false);
}

export function ReportProductsByMisstatementFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportProductsByMisstatement {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'details': json['details'],
        'sum': json['sum'],
    };
}

export function ReportProductsByMisstatementToJSON(value?: ReportProductsByMisstatement | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'details': value.details,
        'sum': value.sum,
    };
}


